import './ContactInfo.scss';

import { useTranslation } from 'react-i18next';

const ContactInfo = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-info">
      <h4
        className="contact-info__title
      contact-info__title--main mb-5"
      >
        {t('Contact.9')}
      </h4>
      <h4 className="contact-info__title mb-2">{t('Contact.10')}</h4>
      <p className="contact-info__text mb-4">
      {t('Contact.11')}
      </p>
      <h4 className="contact-info__title mb-2">{t('Contact.12')}</h4>
      <p className="contact-info__text mb-4">1.800.458.556</p>
      <h4 className="contact-info__title mb-2">{t('Contact.13')}</h4>
      <p className="contact-info__text mb-4">
        support@your-domain.com
        <br />
        help@your-domain.com
        <br />
        {t('Contact.14')}
      </p>
    </div>
  );
};

export default ContactInfo;
